module.exports = ".editButton{cursor:pointer;vertical-align:text-bottom}"